import { getVar } from '../chart-config-builders/builder-helpers';

export const funnelPlugin = {
  id: 'funnelPlugin',
  beforeDatasetDraw(chart, args, options) {
    const {
      ctx,
      config: { type },
      chartArea: { bottom },
    } = chart;

    if (type !== 'funnel') {
      return;
    }

    ctx.save();

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (
        datasetIndex < chart.data.datasets.length - 1 &&
        dataset.data.length
      ) {
        const meta = chart.getDatasetMeta(datasetIndex);
        const nextMeta = chart.getDatasetMeta(datasetIndex + 1);
        const barThickness = meta.data[0].width / 2;

        const x0 = meta.data[0].x + barThickness;
        const y0 = meta.data[0].y;
        const x1 = nextMeta.data[0].x - barThickness;
        const y1 = nextMeta.data[0].y;

        const cp1X = x0 + (x1 - x0) * 0.4;
        const cp1Y = y0 + (y1 - y0) * 0;
        const cp2X = x0 + (x1 - x0) * 0.6;
        const cp2Y = y0 + (y1 - y0) * 1;

        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.bezierCurveTo(cp1X, cp1Y, cp2X, cp2Y, x1, y1);
        ctx.lineTo(x1, bottom);
        ctx.lineTo(x0, bottom);
        ctx.closePath();
        ctx.fillStyle = '#DCEAFF';
        ctx.fill();
      }
    });

    ctx.restore();
  },
  afterDatasetsDraw(chart) {
    const {
      ctx,
      config: { type },
    } = chart;

    if (type !== 'funnel') {
      return;
    }

    chart.data.datasets.forEach(function(dataset, datasetIndex) {
      if (
        datasetIndex < chart.data.datasets.length - 1 &&
        dataset.data.length
      ) {
        const currentData = dataset?.data[0]?.y || 0;
        const nextData =
          chart?.data?.datasets[datasetIndex + 1]?.data[0]?.y || 0;
        let percentageChange =
          100 + ((nextData - currentData) / currentData) * 100;

        percentageChange =
          percentageChange % 1
            ? percentageChange.toFixed(2)
            : Math.round(percentageChange);
        // eslint-disable-next-line prefer-destructuring
        const currentBar = chart.getDatasetMeta(datasetIndex).data[0];
        // eslint-disable-next-line prefer-destructuring
        const nextBar = chart.getDatasetMeta(datasetIndex + 1).data[0];
        const midX = (currentBar.x + nextBar.x) / 2;
        const midY = chart.chartArea.bottom - 12;

        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'black';
        ctx.font = '500 15px Poppins';
        ctx.fillText(`${percentageChange || 0}%`, midX, midY);
        ctx.restore();
      }

      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach(function(bar, index) {
        const data = dataset.data[index].yFormatted;
        ctx.save();
        ctx.textAlign = 'left';
        ctx.textBaseline = 'bottom';
        ctx.fillStyle = 'white';
        ctx.font = '500 20px Poppins';

        const padding = 8;
        const borderRadius = 4;

        const textMetrics = ctx.measureText(data);
        const textWidth = textMetrics.width;
        const textHeight = 16;

        if (bar.height < 35) {
          const boxWidth = textWidth + padding * 2;
          const boxHeight = 30;
          const boxX = bar.x - bar.width / 2 + 15 - padding;
          const boxY = chart.chartArea.bottom - boxHeight;

          ctx.beginPath();
          ctx.moveTo(boxX + borderRadius, boxY);
          ctx.lineTo(boxX + boxWidth - borderRadius, boxY);
          ctx.quadraticCurveTo(
            boxX + boxWidth,
            boxY,
            boxX + boxWidth,
            boxY + borderRadius
          );
          ctx.lineTo(boxX + boxWidth, boxY + boxHeight);
          ctx.lineTo(boxX, boxY + boxHeight);
          ctx.lineTo(boxX, boxY + borderRadius);
          ctx.quadraticCurveTo(boxX, boxY, boxX + borderRadius, boxY);
          ctx.closePath();

          ctx.fillStyle = bar.options.backgroundColor;
          ctx.fill();

          ctx.fillStyle = 'white';
          ctx.fillText(data, boxX + padding, boxY + textHeight + padding + 4);
        } else {
          ctx.fillText(data, bar.x - bar.width / 2 + 15, bar.y + 35);
        }

        ctx.restore();

        let label = dataset.data[index].aggregationLabel;
        if (label.length > 20) {
          label = `${label.slice(0, 20)}...`;
        }

        ctx.textAlign = 'left';
        ctx.textBaseline = 'bottom';
        ctx.font = '400 12px Poppins';
        ctx.fillStyle = getVar('--fc-color-gray-800');
        ctx.fillText(label, bar.x - bar.width / 2, meta.yScale.bottom + 28);
        ctx.restore();
      });
    });
  },
};
